import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectCategory && _ctx.selectCategory(...args))),
    onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.selectCategory && _ctx.selectCategory(...args)), ["enter"])),
    class: _normalizeClass(["w-full grid category-box gap-2 cursor-pointer transform transition-all duration-200 place-content-center p-4", _ctx.selectedClasses])
  }, [
    _createElementVNode("h4", null, _toDisplayString(_ctx.category.title), 1)
  ], 34))
}